export interface BasicModalProps {
    isOpen: boolean
    onClose: () => void
}

// Runtime mapping of modal keys; also used to derive the string-union type below
export const MODAL_STATE = {
    TRY_IT: 'TRY_IT',
    FOOTBALL: 'FOOTBALL',
    VOLLEYBALL: 'VOLLEYBALL',
    OTHERS: 'OTHERS',
    SPORT_EVENT: 'SPORT_EVENT',
    CONTACT_US: 'CONTACT_US',
    MOBILE_MENU: 'MOBILE_MENU',
    COOKIE_CONSENT: 'COOKIE_CONSENT',
    JOIN_COMMUNITY: 'JOIN_COMMUNITY'
} as const

// ModalKey is a string-union of the values above (e.g. 'TRY_IT' | 'FOOTBALL' | ...)
export type ModalKey = (typeof MODAL_STATE)[keyof typeof MODAL_STATE]

export type ModalStore = {
    // single field that stores which modal is open (or null when none)
    currentModal: ModalKey | null

    // actions
    openModal: (key: ModalKey) => void
    closeModal: () => void
    toggleModal: (key: ModalKey) => void
    isModalOpen: (key: ModalKey) => boolean
}
